module.exports = __webpack_public_path__ + "img/Knee.724b1dab.png";